export default {
  name: 'Recibos de Pagamento',
  children: [
    {
      name: 'Recibo Mensal',
      value: 'recibo',
      options: {
        showStockingSelect: true,
        showWorkerSelect: true,
        showJobDescriptionSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
        showOrderBy: true,
      },
    },
    {
      name: 'Recibo de Adiantamento Salarial',
      value: 'recibo-adt',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
        showOrderBy: true,
      },
    },
    {
      name: 'Recibo de Férias',
      value: 'recibo-ferias',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Recibo de Vale Transporte',
      value: 'recibo-vt',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Recibo de Vale Alimentação/Refeição',
      value: 'recibo-va-vr',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: false,
      },
    },
    {
      name: 'Recibo de Décimo Terceiro - Adiantamento',
      value: 'recibo-131',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateYearPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Recibo de Décimo Terceiro - Integral',
      value: 'recibo-132',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateYearPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Termo de Rescisão de Contrato de Trabalho',
      value: 'recibo-rescisao',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
    {
      name: 'Recibo de Adiantamento de Bolsa Estágio',
      value: 'recibo-adt-est',
      options: {
        showDateMonthPeriod: true,
      },
    },
    {
      name: 'Recibo de Pagamento à Autônomo - RPA',
      value: 'SELF_EMPLOYED_PAYMENT_RECEIPT',
      options: {
        showDateMonthPeriod: true,
      },
    },
    {
      name: 'Recibo de Pensão Alimentícia',
      value: 'recibo-penali',
      options: {
        showStockingSelect: true,
        showJobDescriptionSelect: true,
        showWorkerSelect: true,
        showDateMonthPeriod: true,
        showGroupBy: true,
      },
    },
  ],
};
